/**
/* slick
 * ========================================================================== */
$(function() {
    $(".slick-roadside").slick({
      autoplay: false,
      slidesToShow: 2,
      responsive: [
          {
              breakpoint: 619,
              settings: {
                slidesToShow: 1,
              },
          },
      ],
    });
});


/**
/* 画面分割スクロール
 * ========================================================================== */
$(window).on('load resize', function() {
  var windowWidth = window.innerWidth;
  var elements = $('#fixed-area');
  if (windowWidth >= 768) {
    Stickyfill.add(elements);
  }else{
    Stickyfill.remove(elements);
  } 
});
$(function () {
  $(window).on('load scroll',function () {
    const windowHeight = $(window).height();
    const scroll = $(window).scrollTop();
    var windowWidth = window.innerWidth;
    if (windowWidth >= 900) {
      $('#container01').each(function () {
        const targetPosition01 = $(this).offset().top;
        if (scroll > targetPosition01 - windowHeight + 300) {
          $('#fixed-area img').attr('src', '../img/location/park-map01.png');
        }
      });
      $('#container02').each(function () {
        const targetPosition02 = $(this).offset().top;
        if (scroll > targetPosition02 - windowHeight + 300) {
          $('#fixed-area img').attr('src', '../img/location/park-map02.png');
        }
      });
      $('#container03').each(function () {
        const targetPosition03 = $(this).offset().top;
        if (scroll > targetPosition03 - windowHeight + 300) {
          $('#fixed-area img').attr('src', '../img/location/park-map03.png');
        }
      });
      $('#container04').each(function () {
        const targetPosition04 = $(this).offset().top;
        if (scroll > targetPosition04 - windowHeight + 300) {
          $('#fixed-area img').attr('src', '../img/location/park-map04.png');
        }
      });
    }
  });
});